import QueryKeys from '@/utils/QueryKeys';
import { plato_api_programs_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseProgram, ExtraAttributes, ProgramSchema } from '@/types/api/v2/ProgramSchema';
import useApi from './useApi';

interface UseProgramParams<K extends (keyof BaseProgram)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseProgramsOptions<K extends (keyof BaseProgram)[], E extends (keyof ExtraAttributes)[]> =
  UseProgramParams<K, E> & Omit<UseQueryOptions<ProgramSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function usePrograms<
  K extends(keyof BaseProgram)[],
  E extends (keyof ExtraAttributes)[],
>({
  extra_attributes = ([] as any as E),
  only,
  params = {},
  ...queryOptions
}: UseProgramsOptions<K, E>) {
  return useApi<ProgramSchema<K[number], E[number]>[], BaseProgram, K, ExtraAttributes, E>({
    endpoint: plato_api_programs_path({ extra_attributes, only }),
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.Programs, extra_attributes, only],
    ...queryOptions,
  });
}
